import { gsap } from "gsap";

export const LetterMotion = {
  init:(isContent)=>{
    let target="";
    if(!isContent){
      target = document.querySelectorAll('.js-char');
    }
    else{
      target = document.querySelectorAll('.js-charContent');
    }
    const wrapCharSpan = function(str){
      return [...str].map(char => {
        return (!char.match(/\S/g)) ? `<span class="emp">${char}</span>` : `<span>${char}</span>`;
      }).join('');
    }
    target.forEach(function(item){
      item.innerHTML = wrapCharSpan(item.textContent);
    })
    LetterMotion.addEvent(isContent)
  },
  letterMotion:(el)=>{
    let t1_span=el.children[0].children[0].children[0].children;
    let t2_span=el.children[0].children[0].children[1].children;
    gsap.set(t1_span,{y:"0%"})
    gsap.set(t2_span,{y:"100%"})
    gsap.to(t1_span,0.4,{
      ease:'Power3.easeInOut',
      y:"-112%",
      stagger:0.03
    })
    gsap.to(t2_span,0.6,{
      ease:'Power3.easeInOut',
      y:"0%",
      stagger:0.03,
      onComplete:()=>{
        setTimeout(()=>{
          el.classList.remove('is-in')
        },500)
      }
    })
  },
  addEvent:(isContent)=>{
    let letters = "";
    if(!isContent){
      letters=document.querySelectorAll(".js-hover-letter");
    }
    else{
      letters=document.querySelectorAll(".js-hover-letterContent");
    }
    for (let i = 0, li = letters.length; i < li; i++) {
      letters[i].addEventListener("mouseover", function(){
        if(!letters[i].classList.contains("is-in")){
          letters[i].classList.add('is-in')
          LetterMotion.letterMotion(letters[i])
        }
      }, true);
      // letters[i].addEventListener("mouseout", function(){
      // }, true);
    }
  },
  removeEvent:()=>{

  }
};
